export const adminCreateApplication = `mutation adminCreateApplication($input: ApplicationCreateInput!) {
  adminCreateApplication(input: $input) {
    applicationId
  }
}`;

export const adminUpdateApplication = `mutation adminUpdateApplication($input: ApplicationUpdateInput!) {
  adminUpdateApplication(input: $input) {
      applicationId
      type
      group
      name
      label
      description
      version
      active
      adminOnly
      modules {
        name
        filename
      }
      aam
      env {
        key
        value
      }
  }
}`;

export const adminDeleteApplication = `mutation adminDeleteApplication($applicationId: ID!) {
  adminDeleteApplication(applicationId: $applicationId) {
      applicationId
  }
}`;

export const adminUpdateApplicationUsers = `mutation adminUpdateApplicationUsers($applicationId: ID!, $users: [ID]) {
  adminUpdateApplicationUsers(applicationId: $applicationId, users: $users) {
      applicationId
      users
  }
}`;
